import { DataCache, DataCacheCollection, ForeignKeyRelationship, QueryResultsRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';

import { HomePageDateMovements, HomePagePortMovements, HomePageMovement } from 'data/models/HomePage';

export class HomePageCache extends DataCache {
    HomePageDateMovements = PCCollection(HomePageDateMovements);
    HomePagePortMovements = PCCollection(HomePagePortMovements);
    HomePageMovements = PCCollection(HomePageMovement);

    constructor(data : PCCache) {
        super();

        new QueryResultsRelationship(this.HomePageDateMovements, this.HomePagePortMovements, d => d.Ports);
        new QueryResultsRelationship(this.HomePagePortMovements, this.HomePageMovements, p => p.Movements);
        new ForeignKeyRelationship(data.ItineraryPoints, this.HomePageMovements, null, m => m.FromPoint, m => m.FromPointId());
        new ForeignKeyRelationship(data.ItineraryPoints, this.HomePageMovements, null, m => m.ToPoint, m => m.ToPointId());
        new QueryResultsRelationship(this.HomePageMovements, data.CoordinationCards, m => m.TrafficCoordinationCards);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/homepage/cache.ts